import React from "react";
import "./zdcardDetail.less";
import {
  Col,
  Empty,
  Popover,
  Row,
  Space,
  Typography,
  Tooltip,
  Button,
  message,
} from "antd";
import { StarOutlined, FireOutlined } from "@ant-design/icons";
import Sc from "@/assets/images/sc.svg";
import Qxsc from "@/assets/images/qxsc.svg";
import Rd from "@/assets/images/rd.svg";
import API from "@/api";
import axios from "axios";

function CardDetail(props) {
  const { data, onClick, style, mobile = false, scRefresh } = props;
  console.log(data, "智能体广场的数据");
  const newData = [];
  data?.map((item) => {
    if (mobile) {
      if (item.alloweddevice * 1 === 2 || item.alloweddevice * 1 === 0) {
        newData.push(item);
      }
    } else {
      if (item.alloweddevice * 1 === 0 || item.alloweddevice === 1) {
        newData.push(item);
      }
    }
  });
  console.log(mobile, "是否是移动端");

  const formatDialogCount = (count) => {
    const num = Number(count);

    // 处理非数字/负数/NaN情况，默认显示0
    if (isNaN(num) || num <= 0) {
      return "0";
    }

    // 转为整数（避免小数干扰，比如12.9→12、"1492.5"→1492）
    const intNum = Math.floor(num);
    // 1位数（0-9）：直接显示
    if (num < 10) {
      return String(num);
    }

    // 2位数（10-99）：十位数字 + "0+"
    if (num < 100) {
      const tens = Math.floor(num / 10); // 提取十位数字
      return `${tens}0+`;
    }

    // 3位数（100-999）：百位数字 + "00+"
    if (num < 1000) {
      const hundreds = Math.floor(num / 100); // 提取百位数字
      return `${hundreds}00+`;
    }

    // 4位数（1000-9999）：千位数字 + "000+"
    if (num < 10000) {
      const thousands = Math.floor(num / 1000); // 提取千位数字
      return `${thousands}000+`;
    }

    // ≥5位数：x.y万+（y为0时不显示）
    const wan = Math.floor(num / 10000); // 提取万位及以上的整数部分
    const qian = Math.floor((num % 10000) / 1000); // 提取千位数字（0-9）

    if (qian === 0) {
      return `${wan}万+`;
    } else {
      return `${wan}.${qian}万+`;
    }
  };

  return (
    <Row gutter={[32, 32]} className="zdCardDetail" style={style}>
      {newData?.length ? (
        newData?.map((item, index) => {
          return mobile ? (
            <div
              className="m-znt-space"
              key={index}
              style={{ cursor: "pointer" }}
            >
              <div
                className="listItem"
                key={index}
                onClick={() => {
                  onClick?.(item);
                }}
              >
                {item.outerznt ? (
                  <div
                    className="agent-tags"
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    <Button
                      size="small"
                      shape="round"
                      color="primary"
                      variant="filled"
                    >
                      外链
                    </Button>
                  </div>
                ) : null}
                <div className="iconContent">
                  <div className="icon">
                    <img src={item?.icon} />
                  </div>
                  <div className="wrapContent">
                    <div className="titleAndContent">
                      <div className="cardTitle">{item.label}</div>
                      <Tooltip content={item?.summary ?? ""}>
                        <Typography.Paragraph
                          ellipsis={{ rows: 2 }}
                          style={{
                            color: "rgb(51, 51, 51)",
                            fontSize: 13,
                            opacity: 0.6,
                            fontWeight: 400,
                            fontFamily: "思源黑体 CN",
                          }}
                        >
                          {item?.summary ?? ""}
                        </Typography.Paragraph>
                      </Tooltip>
                    </div>
                  </div>
                </div>

                <div className="agreeAndCollect">
                  <div className="icons zdIcons">
                    <Row gutter={[16, 16]}>
                      <Col span={8}>
                        <div>
                          <span>
                            {item.favorite ? (
                              <img
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  cursor: "pointer",
                                }}
                                src={Sc}
                                alt=" "
                                  onClick={() => {
                                  axios
                                    .get(
                                      API.cancelFavorite +
                                        `?zntId=${item.zntId}`
                                    )
                                    .then(() => {
                                      scRefresh();
                                      message.success("取消成功");
                                    });
                                }}
                              />
                            ) : (
                              <img
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  cursor: "pointer",
                                }}
                                src={Qxsc}
                                alt=" "
                                 onClick={() => {
                                 axios
                                    .get(
                                      API.addFavorite + `?zntId=${item.zntId}`
                                    )
                                    .then(() => {
                                      scRefresh();
                                      message.success("收藏成功");
                                    });
                                }}
                              />
                            )}
                          </span>
                          <span
                            style={{
                              lineHeight: "25px",
                              paddingLeft: "4px",
                            }}
                          >
                            {item.favoriteNum}
                          </span>
                        </div>
                      </Col>
                      <Col span={8}>
                        <div>
                          <span>
                            <img
                              style={{
                                width: "25px",
                                height: "20px",
                              }}
                              src={Rd}
                              alt=" "
                            />
                          </span>

                          <span>{formatDialogCount(item.qaNum)}</span>
                        </div>
                      </Col>
                      <Col span={8}>
                        <div>
                          {item.owner?.name ? (
                            <Tooltip title={item.owner?.name}>{`@${
                              item.owner?.name.length > 6
                                ? item.owner?.name.slice(0, 5) + "..."
                                : item.owner?.name
                            }`}</Tooltip>
                          ) : (
                            ""
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Col
              className="znt-col"
              xs={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 8 }}
              key={index}
            >
              <div className="listItem" key={index}>
                {item.outerznt ? (
                  <div
                    className="agent-tags"
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    <Button
                      size="small"
                      shape="round"
                      color="primary"
                      variant="filled"
                    >
                      外链
                    </Button>
                  </div>
                ) : null}
                <div
                  className="iconContent"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    onClick?.(item);
                  }}
                >
                  <div className="icon">
                    <img src={item?.icon} />
                  </div>
                  <div className="wrapContent">
                    <div className="titleAndContent">
                      <div className="cardTitle"><Tooltip title={item.label} >{item.label}</Tooltip></div>
                      <Tooltip content={item?.summary ?? ""}>
                        <Typography.Paragraph
                          ellipsis={{ rows: 2 }}
                          style={{
                            color: "rgb(51, 51, 51)",
                            fontSize: 13,
                            opacity: 0.6,
                            fontWeight: 400,
                            fontFamily: "思源黑体 CN",
                            padding: "0",
                          }}
                        >
                          {item?.summary ?? ""}
                        </Typography.Paragraph>
                      </Tooltip>
                    </div>
                  </div>
                </div>
                <div className="agreeAndCollect">
                  <div className="icons zdIcons">
                    <Row gutter={[16, 16]}>
                      <Col span={6}>
                        <div>
                          <span>
                            {item.favorite ? (
                              <img
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  cursor: "pointer",
                                }}
                                src={Sc}
                                alt=" "
                                onClick={() => {
                                  axios
                                    .get(
                                      API.cancelFavorite +
                                        `?zntId=${item.zntId}`
                                    )
                                    .then(() => {
                                      scRefresh();
                                      message.success("取消成功");
                                    });
                                }}
                              />
                            ) : (
                              <img
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  cursor: "pointer",
                                }}
                                src={Qxsc}
                                alt=" "
                                onClick={() => {
                                  axios
                                    .get(
                                      API.addFavorite + `?zntId=${item.zntId}`
                                    )
                                    .then(() => {
                                      scRefresh();
                                      message.success("收藏成功");
                                    });
                                }}
                              />
                            )}
                          </span>
                          <span
                            style={{
                              lineHeight: "25px",
                              paddingLeft: "4px",
                            }}
                          >
                            {item.favoriteNum}
                          </span>
                        </div>
                      </Col>
                      <Col span={6}>
                        <div style={{
                          lineHeight:"24px"
                        }}>
                          <span>
                            <img
                              style={{
                                width: "25px",
                                height: "20px",
                              }}
                              src={Rd}
                              alt=" "
                            />
                          </span>

                          <span>{formatDialogCount(item.qaNum)}</span>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div style={{
                          lineHeight:"25px",
                          textAlign:"right"
                        }}>
                          {item.owner?.name ? (
                            <Tooltip title={item.owner?.name}>{`@${
                              item.owner?.name.length > 6
                                ? item.owner?.name.slice(0, 5) + "..."
                                : item.owner?.name
                              // item.owner?.name
                            }`}</Tooltip>
                          ) : (
                            ""
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          );
        })
      ) : (
        <Col span={24}>
          <div style={{ textAlign: "center", paddingTop: "20px" }}>
            <Typography.Text style={{ textAlign: "center" }} type="secondary">
              <Empty style={{ height: 50 }} description={"暂无数据"}></Empty>
            </Typography.Text>
          </div>
        </Col>
      )}
      <div></div>
    </Row>
  );
}

export default CardDetail;
